import { Box, Button, Dialog } from '@mui/material';
import { useMutation } from '@apollo/client';
import { errorToast, successToast } from '../../../common/utils/alert';
import { errorMessages } from '../../../common/utils/constants';
import { DELETE_MEMBER_SKILL } from '../../gql';
interface IDeleteToolsProps {
  onCancel: () => void;
  onClose: () => void;
  isVisible: boolean;
  memberSkillId?: string;
  updateMemberSkillsCallback: () => Promise<void>;
}

const DeleteToolsForm = ({
  onCancel,
  onClose,
  memberSkillId,
  isVisible,
  updateMemberSkillsCallback
}: IDeleteToolsProps): JSX.Element => {
  const [deleteMemberSkillMutation, { loading }] =
    useMutation(DELETE_MEMBER_SKILL);

  const handleDelete = (): void => {
    onClose();

    deleteMemberSkillMutation({
      variables: { id: memberSkillId }
    })
      .then(async () => {
        successToast('Member Skill Deleted Successfully');
        await updateMemberSkillsCallback();
      })
      .catch(() => {
        errorToast(errorMessages.ErrorMessageDeleteMemberSkill);
      });
  };

  return (
    <Dialog
      sx={{
        '.MuiPaper-root': {
          boxShadow: 'none',
          backgroundColor: 'transparent'
        }
      }}
      open={isVisible}
    >
      <Box
        sx={{
          borderRadius: '28px',
          background:
            'linear-gradient(0deg, rgba(41, 93, 171, 0.11), rgba(41, 93, 171, 0.11)), #FDFBFF'
        }}
      >
        <Box
          sx={{
            fontFamily: 'Be Vietnam Pro',
            fontWeight: 500,
            fontSize: '24px',
            color: '#1A1B1F',
            textAlign: 'center',
            padding: '36px 80px'
          }}
        >
          Are you sure you want to remove this Tool or Technology?
        </Box>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            padding: '24px'
          }}
        >
          <Button
            sx={{
              padding: '10px 12px 10px 12px',
              fontSize: '18px',
              fontWeight: 500,
              color: '#295DAB',
              textTransform: 'none'
            }}
            onClick={onCancel}
            data-testid="cancel-button"
          >
            Dismiss
          </Button>
          <Button
            sx={{
              padding: '10px 12px 10px 12px',
              fontSize: '18px',
              fontWeight: 500,
              color: '#295DAB',
              textTransform: 'none'
            }}
            onClick={handleDelete}
            disabled={loading}
            data-testid="yes-delete-button"
          >
            Yes, Approve
          </Button>
        </Box>
      </Box>
    </Dialog>
  );
};

export default DeleteToolsForm;
